import React from "react";
import Footer from "../components/Footer";
import ReturnsGrid from "./Grid";
import CancelButton from "../components/Buttons/CancelButton";
import NextButton from "../components/Buttons/NextButton";
import { redirectToIBPlanning } from "../utils";
import { getDataWithQueryString } from "./../../../../api/componentAPIs";
import BackButton from "../components/Buttons/BackButton";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withPlanDate } from "../PlanDateContext";
import { sortBy } from 'lodash';

class Returns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      returns: null,
    };
    this.gridApi = {};
  }

  componentDidMount() {
    const {
      userData: { userProfile },
      planDate,
    } = this.props;
    getDataWithQueryString(
      "GetReturnShipmentsForPlan",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${planDate}`
    ).then(
      (returns) => {
        if (returns && returns.status === 200) {
          this.setState({
            returns: sortBy(returns.data, [(item) => !item.isInPlan]),
          });
          this.selectPros();
        } else {
          this.props.enqueueSnackbar("Unable to fetch return shipments", {
            variant: "error",
          });
          this.setState({
            returns: [],
          });
        }
      },
      (_error) => {
        this.props.enqueueSnackbar("Unable to fetch return shipments", {
          variant: "error",
        });
        this.setState({
          returns: [],
        });
      }
    );
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (
        this.props.selectedShipmentIds.includes(node.data.proId) ||
        node.data.isInPlan
      ) {
        node.setSelected(true);
      }
    });
  };

  handleNext = () => {
    this.props.goToNextStep(
      this.gridApi
        .getSelectedRows()
        .filter((pro) => !pro.isInPlan)
        .map((pro) => pro.proId)
    );
  };

  render() {
    return (
      <>
        <ReturnsGrid
          rowData={this.state.returns}
          onGridReady={this.onGridReady}
          glEventHub={this.props.glEventHub}
          userProfile={this.props.userData.userProfile}
          serviceLevelList={this.props.serviceLevelList}
        />
        <Footer>
          <CancelButton onClick={redirectToIBPlanning} />
          <BackButton onClick={this.props.goBack} />
          <NextButton
            onClick={this.handleNext}
            disabled={!this.state.returns}
          />
        </Footer>
      </>
    );
  }
}

export default compose(withPlanDate, withSnackbar, withUserProfile)(Returns);
